export default __webpack_public_path__ + "static/2019-01-Remax-EXPERTS-balon-PNG-049608a442dbd9668fca86c3b477a5cd.png";